import React from 'react';
import {
    Box,
    Grid,
    Typography,
    Card,
    CardContent,
    CardMedia,
    Container
} from '@mui/material';

const newsItems = [
    {
        title: 'ЭТП: обсуждаются возможные обновления процессов аккредитации',
        image: 'news/5.jpg',
        date: '17 сентября 2025'
    },
    {
        title: 'Отраслевые участники отмечают повышенный интерес к пилотам на ЭТП',
        image: 'news/6.jpg',
        date: '12 сентября 2025'
    },
    {
        title: 'Сообщается о предварительных консультациях по интеграциям ЭТП',
        image: 'news/1.jpg',
        date: '3 сентября 2025'
    },
    {
        title: 'В ряде регионов рассматриваются инициативы по локализации через ЭТП',
        image: 'news/2.jpg',
        date: '28 августа 2025'
    },
    {
        title: 'Некоторые компании изучают расширение участия на ЭТП',
        image: 'news/3.jpg',
        date: '20 августа 2025'
    },
    {
        title: 'Обсуждаются подходы к повышению прозрачности на ЭТП',
        image: 'news/4.jpg',
        date: '14 августа 2025'
    }
];

const CompanyNews: React.FC = () => {
    // Split news items into two rows
    const firstRowItems = newsItems.slice(0, 2);
    const secondRowItems = newsItems.slice(2, 6);

    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <Typography variant="h4" gutterBottom fontWeight={600}>
                Последние новости
            </Typography>

            {/* First row - 2 bigger news items */}
            <Grid container spacing={3} sx={{ mb: 3 }}>
                {firstRowItems.map((item, index) => (
                    <Grid item xs={12} sm={6} md={6} key={index}>
                        <Card sx={{ height: '100%' }}>
                            {/* Изображение скрыто для MVP презентации */}
                            {/*
                            <CardMedia
                                component="img"
                                height="240"
                                image={item.image}
                                alt={item.title}
                            />
                            */}
                            <CardContent>
                                <Typography variant="caption" color="text.secondary">
                                    {item.date}
                                </Typography>
                                <Typography variant="subtitle1" fontWeight="bold" color="text.primary" gutterBottom>
                                    {item.title}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            {/* Second row - 4 smaller news items */}
            <Grid container spacing={3}>
                {secondRowItems.map((item, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index + 2}>
                        <Card sx={{ height: '100%' }}>
                            {/* Изображение скрыто для MVP презентации */}
                            {/*
                            <CardMedia
                                component="img"
                                height="160"
                                image={item.image}
                                alt={item.title}
                            />
                            */}
                            <CardContent>
                                <Typography variant="caption" color="text.secondary">
                                    {item.date}
                                </Typography>
                                <Typography variant="subtitle1" fontWeight="bold" color="text.primary" gutterBottom>
                                    {item.title}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

export default CompanyNews;
